import { render, staticRenderFns } from "./BldrComponentConfigs.vue?vue&type=template&id=723621b2"
import script from "./BldrComponentConfigs.vue?vue&type=script&lang=js"
export * from "./BldrComponentConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports